import ActionCellRender from "../../components/actionCellRender";
import { IconPencil, IconTrash } from "@tabler/icons-react";

export const UserGroupTableSchema = (cellRender) => {
  return {
    showActionColumn: true,
    columns: [
      {
        field: "name",
        headerName: "Group Name",
        sortable: true,
      },
      {
        field: "description",
        headerName: "Description",
        sortable: true,
      },
      {
        field: "members",
        headerName: "Members",
        sortable: false,
        cellRender: (col, row) => {
          return row.members ? row.members.length : 0;
        },
      },
      {
        field: "status",
        headerName: "Status",
        sortable: true,
      },
      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {},
          },
          {
            name: "delete",
            icon: IconTrash,
            props: {},
          },
        ],
      },
    ],
    searchableFields: ["name", "code"],
  };
};
